import dayjs from "dayjs";
import { DateTool } from "@js/date-tool.js";

export class UserModel {
  constructor(data) {
    this.id = data.id;
    this.trueName = data.trueName || '-';
    this.sex = this.formatGender(data.sex);
    this.birthday = data.birthday || null;
    this.age = this.calculateAge(data.birthday);
    this.mobile = data.mobile || '-';
    this.mzh = data.mzh || '-';
    this.statusDesc = data.statusDesc || '-';
    this.hospitalName = data.hospitalName || '-';
    this.isReport = data.isReport || 0;
    this.hospitalId = data.hospitalId
  }

  formatGender(sex) {
    return findKey(GENDER_CODE, `${sex}`);
  }

  calculateAge(birthday) {
    if (!birthday) return '-';
    const birthDay = dayjs(birthday);
    if (!birthDay.isValid()) {
      return "-";
    }
    return DateTool.calculateAge(
      birthDay.year(),
      birthDay.month() + 1,
      birthDay.date()
    );
  }

  static fromApiResponse(response) {
    if (!response || !response.list) {
      return [];
    }
    return response.list.map(item => new UserModel(item));
  }
} 